import React from 'react';

import Skeleton from 'coreComponents/Skeleton';

import Link from 'brandComponents/Link';
import Popup from 'brandComponents/Popup';

import {ICelebritiesPopupProps} from './ICelebritiesPopup';

import styles from './CelebritiesPopup.module.scss';

const CelebritiesPopup = ({data, handleOnCancel}: ICelebritiesPopupProps) => {

	if (!data) {
		return null;
	}

	return (
		<Popup
			id="celebrities"
			onClose={handleOnCancel}
			className={styles['celebrities-popup']}
			overlayClassName={styles['celebrities-popup__overlay']}
			popupContentClassName={'celebrities-popup__content'}
		>
			{!data?.imageUrl || (data && data?.imageUrl && data.imageUrl === '') ? (
				<Skeleton width="100%" height="400px" />
			) : (
				<>
					<img className={styles['celebrities-popup__content__image']} src={data.imageUrl} alt={data.title} />
					<div className={styles['celebrities-popup__content__info']}>
						<p>{data.title}</p>
						<Link to={data.cta.link}>{data.cta.title}</Link>
					</div>
				</>
			)}
		</Popup>
	);
};
export default CelebritiesPopup;
